import CableReady from 'cable_ready'
import consumer from "./consumer"


$(document).on('turbolinks:load', function () {

    let lobby_id = $('#lobby').attr('data-lobby-id')
    let user_id = $('#lobby').attr('data-user-id')
    if (lobby_id != null)
        consumer.subscriptions.create({channel: "LobbyChannel", lobby_id: lobby_id, user_id: user_id}, {
            connected() {
                // Called when the subscription is ready for use on the server

                console.log("Conectado al lobby ...: ", lobby_id)
            },

            disconnected() {
                // Called when the subscription has been terminated by the server
                console.log("Desconectado del lobby ...: ", lobby_id)
            },

            received(data) {
                // Called when there's incoming data on the websocket for this channel
                console.log("data: ", data)
                if (data.cableReady) CableReady.perform(data.operations)

                // $('#confirmModal').modal('show')

                // Timer confirm
                if (data.head === 205) {
                    if (typeof idTimer !== 'undefined'){
                        clearInterval(idTimer)
                    }
                    let seconds = 1 * data.time_remaining_go
                    startTimer(seconds, 'playClockdiv')
                }

                // Timer entrar al server
                if (data.head === 206){
                    clearInterval(idTimer)
                    let seconds = 1 * data.time_remaining_server
                    startTimer(seconds, "clockdiv")
                }

                if (data.head === 302) {
                    window.location.pathname = data.path;
                }
            }
        });

    else
        consumer.disconnect()
});